// src/sectors/pilates/members/components/MemberActionsMenu/MembersActionsMenu.jsx
import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useTheme as useMuiTheme } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function MembersActionsMenu({
  anchorEl,
  open,
  onClose,
  member,
  onDetail,
  onToggleActive,
  onEdit,
  // ✅ yeni
  onMessageSoon,
  onOpenPayment,
}) {
  const theme = useMuiTheme();

  const isInactive = member?.active === false;
  const hasDebt =
    (typeof member?.debtTry === 'number' && member.debtTry > 0) ||
    (typeof member?.balanceCents === 'number' && member.balanceCents > 0);

  const handle = (fn) => () => {
    fn?.(member);
    onClose?.();
  };

  const items = [];

  items.push(
    <MDBox key="hdr" sx={{ px: 2, py: 1.25 }}>
      <MDTypography variant="caption" fontWeight="bold" sx={{ opacity: 0.9 }}>
        {member?.fullName || `${member?.name || ''} ${member?.surname || ''}`.trim() || 'İşlemler'}
      </MDTypography>
      <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
        Hızlı aksiyonlar
      </MDTypography>
    </MDBox>
  );

  items.push(<Divider key="d0" />);

  items.push(
    <MenuItem key="detail" onClick={handle(onDetail)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>visibility</Icon>
      </ListItemIcon>
      Detay
    </MenuItem>
  );
  // ✅ düzenle
  items.push(
    <MenuItem key="edit" onClick={handle(onEdit)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>edit</Icon>
      </ListItemIcon>
      Düzenle
    </MenuItem>
  );
  // ✅ ödeme al
  items.push(
    <MenuItem key="pay" onClick={handle(onOpenPayment)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18, color: hasDebt ? theme.palette.warning.main : undefined }}>
          payments
        </Icon>
      </ListItemIcon>
      Ödeme Al
    </MenuItem>
  );

  // ✅ mesaj gönder (çok yakında)
  items.push(
    <MenuItem key="messageSoon" onClick={handle(onMessageSoon)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>{hasDebt ? 'priority_high' : 'sms'}</Icon>
      </ListItemIcon>
      Mesaj Gönder
      <MDTypography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
        (çok yakında)
      </MDTypography>
    </MenuItem>
  );

  items.push(<Divider key="d1" />);

  items.push(
    <MenuItem key="toggleActive" onClick={handle(onToggleActive)}>
      <ListItemIcon>
        <Icon sx={{ fontSize: 18 }}>{!isInactive ? 'block' : 'check_circle'}</Icon>
      </ListItemIcon>
      {!isInactive ? 'Pasife Al' : 'Aktifleştir'}
    </MenuItem>
  );

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '18px',
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
          minWidth: 260,
          boxShadow: theme.shadows[10],
        },
      }}
    >
      {items}
    </Menu>
  );
}
